<template>
    <div>
        <label class="form-label">{{ trans('general.attachments.label') }}</label>
        <attachments
            :attachments="attachments"
            :can-create="true"
            :can-delete="true"
            :can-edit="true"
            :can-read="true"
            :form="modelValue"
            @updated-attachment="$emit('updatedAttachment', $event)"
            @deleted-attachment="$emit('deletedAttachment', $event)"
        />
    </div>
</template>
<script setup>
import { trans } from '@/mixins/i18n';
import Attachments from '@/Components/Attachments.vue';

const props = defineProps({
    modelValue: Object,
    attachments: Array,
    errors: {},
});

defineEmits(['updatedAttachment', 'deletedAttachment']);
</script>
